// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comp-card {
  display: flex;
  flex-direction: row;
  background: var(--color-pages-me-card-background);
  border: 1px solid var(--color-pages-me-card-border);
  padding: 12px;
  border-radius: 4px;
  position: relative;
}
.comp-card .card-time {
  border-right: 1px solid var(--color-pages-me-card-border);
  margin-right: 20px;
  width: 26%;
  min-width: 144px;
  font-family: Ubuntu-L, sans-serif;
  opacity: 0.4;
}
.comp-card .card-info {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}
.comp-card .card-info .info-title {
  font-family: Ubuntu-M, sans-serif;
  font-size: 18px;
  display: flex;
  flex-direction: row;
  color: var(--color-pages-me-card-text);
  opacity: 0.6;
}
.comp-card .card-info .info-text {
  font-family: Ubuntu-R, sans-serif;
  font-size: 14px;
  color: var(--color-pages-me-card-text);
  opacity: 0.6;
}
.comp-card .card-info .info-dev {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.comp-card .card-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.031372549);
  height: 4px;
}
.comp-card .card-bottom .bottom-lab {
  height: 100%;
  background: var(--color-featureColor);
  width: 28%;
  opacity: 0.5;
}

.comp-card:hover .card-time {
  opacity: 1;
}
.comp-card:hover .card-info .info-title {
  opacity: 1;
}
.comp-card:hover .card-info .info-text {
  opacity: 1;
}
.comp-card:hover .card-bottom .bottom-lab {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/historyCard/historyCard.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,iDAAA;EACA,mDAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AACF;AACE;EACE,yDAAA;EACA,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,iCAAA;EACA,YAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;AAAJ;AAEI;EACE,iCAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,sCAAA;EACA,YAAA;AAAN;AAGI;EACE,iCAAA;EACA,eAAA;EACA,sCAAA;EACA,YAAA;AADN;AAII;EACE,aAAA;EACA,QAAA;EACA,eAAA;AAFN;AAME;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,4CAAA;EACA,WAAA;AAJJ;AAMI;EACE,YAAA;EACA,qCAAA;EACA,UAAA;EACA,YAAA;AAJN;;AAWE;EACE,UAAA;AARJ;AAYI;EACE,UAAA;AAVN;AAaI;EACE,UAAA;AAXN;AAgBI;EACE,UAAA;AAdN","sourcesContent":[".comp-card {\n  display: flex;\n  flex-direction: row;\n  background: var(--color-pages-me-card-background);\n  border: 1px solid var(--color-pages-me-card-border);\n  padding: 12px;\n  border-radius: 4px;\n  position: relative;\n\n  .card-time {\n    border-right: 1px solid var(--color-pages-me-card-border);\n    margin-right: 20px;\n    width: 26%;\n    min-width: 144px;\n    font-family: Ubuntu-L, sans-serif;\n    opacity: 0.4;\n  }\n\n  .card-info {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    width: 100%;\n\n    .info-title {\n      font-family: Ubuntu-M, sans-serif;\n      font-size: 18px;\n      display: flex;\n      flex-direction: row;\n      color: var(--color-pages-me-card-text);\n      opacity: 0.6;\n    }\n\n    .info-text {\n      font-family: Ubuntu-R, sans-serif;\n      font-size: 14px;\n      color: var(--color-pages-me-card-text);\n      opacity: 0.6;\n    }\n\n    .info-dev {\n      display: flex;\n      gap: 8px;\n      flex-wrap: wrap;\n    }\n  }\n\n  .card-bottom {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: #ffffff08;\n    height: 4px;\n\n    .bottom-lab {\n      height: 100%;\n      background: var(--color-featureColor);\n      width: 28%;\n      opacity: 0.5;\n    }\n  }\n}\n\n.comp-card:hover {\n\n  .card-time {\n    opacity: 1;\n  }\n\n  .card-info {\n    .info-title {\n      opacity: 1;\n    }\n\n    .info-text {\n      opacity: 1;\n    }\n  }\n\n  .card-bottom {\n    .bottom-lab {\n      opacity: 1;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
